import { render, staticRenderFns } from "./forgotPass.vue?vue&type=template&id=5b7dd1bc&scoped=true"
import script from "./forgotPass.vue?vue&type=script&lang=js"
export * from "./forgotPass.vue?vue&type=script&lang=js"
import style0 from "./forgotPass.vue?vue&type=style&index=0&id=5b7dd1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7dd1bc",
  null
  
)

export default component.exports